import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "confirmation", "submit"]

  connect() {
    this.sync()
  }

  sync() {
    if (!this.hasPasswordTarget || !this.hasSubmitTarget) return

    if (this.hasConfirmationTarget) {
      const mismatch =
        this.confirmationTarget.value !== "" &&
        this.confirmationTarget.value !== this.passwordTarget.value
      this.confirmationTarget.setCustomValidity(
        mismatch ? "Passwords do not match" : ""
      )
    }

    const passwordOk =
      !!this.passwordTarget.value && this.passwordTarget.checkValidity()
    const confirmationOk =
      !this.hasConfirmationTarget ||
      (!!this.confirmationTarget.value && this.confirmationTarget.checkValidity())

    this.submitTarget.disabled = !(passwordOk && confirmationOk)
  }
}
